<template>
 <span ref="headerContainer" v-show="showHeader">
   <div v-show="showTopHeader" class="main-panel-header-title" >
        <span class="header-left-container">
            <span class="far fa-home oxygen-home-icon " @click="homeIconClicked" v-tooltip="{content: 'Home Menu'}"  ></span>&nbsp;
            <span class="simplia-panel-title">
                <span ref="detailsIcon" v-show="!showDetails" @click="displayDetails" v-tooltip="{content: 'Show Details'}" class="fas fa-info" style="color: lightblue; font-size: 13px; padding-top:3px; cursor: pointer; padding-right:10px;"></span>
                <span v-if="showPanelIndexNum"  style="display:inline-flex; align-items: center;">
                    <span
                        :data-index='parentIndex'
                        class='panel-index'
                        :style="{'font-size':oxygenUtil.config.headerFontSize, 'font-weight': oxygenUtil.config.headerFontWeight}"
                    >{{parentIndex}}</span>/<span

                    :data-index='localIndex'
                    class='panel-index'
                    :style="{'font-size':oxygenUtil.config.headerFontSize, 'font-weight': oxygenUtil.config.headerFontWeight}"
                >{{localIndex}}</span>
                </span>
                &nbsp;
                <template v-if="showThreadSubjectTitle" >
                    <span @click="panelTitleClicked" :style="{'font-size':oxygenUtil.config.headerFontSize, 'font-weight': oxygenUtil.config.headerFontWeight}" class="thread-subject-title" v-if="rootMenuItem.PrettyURL">
                      {{rootMenuItem.PrettyURL}}
                    </span>
                    <span @click="panelTitleClicked" class="thread-subject-title" v-else>
                      <span

                          class="far fa-share-alt title-thread-role"
                          v-show="showThread && showDetails">
                      </span>
                      <span :style="{'font-size':oxygenUtil.config.headerFontSize, 'font-weight': oxygenUtil.config.headerFontWeight}" v-tooltip="{content: rootMenuItem.LeftDN || ''}" class="title-component title-thread">
                        {{oxygenUtil.formatDN(rootMenuItem.LeftDN)}}
                      </span>
                      <span v-show="showThread">&nbsp;/&nbsp;</span>
                      <span
                          v-show="showDetails"

                          class="far fa-share-alt title-subject-role">
                      </span>
                      <span :style="{'font-size':oxygenUtil.config.headerFontSize, 'font-weight': oxygenUtil.config.headerFontWeight}" v-tooltip="{content: parseSubjectDN(rootMenuItem.RightDN) || ''}" class="title-component title-subject">
                         {{oxygenUtil.formatDN(parseSubjectDN(rootMenuItem.RightDN))}}
                      </span>
                      <span :style="{'font-size':oxygenUtil.config.headerFontSize, 'font-weight': oxygenUtil.config.headerFontWeight}" v-if="extendedTitle" v-tooltip="{content: extendedTitle || ''}" class="title-component">
                      &nbsp;&nbsp;/&nbsp;{{extendedTitle}}
                      </span>
                    </span>
                </template>
                <span :style="{'font-size':oxygenUtil.config.headerFontSize, 'font-weight': oxygenUtil.config.headerFontWeight}" class="thread-subject-title" v-else>
                  {{simpleTitle}}
                </span>
            </span>
        </span>
        <span class="rightmenu-container">
            <span
                class="screen-size-icon far fa-ellipsis-v"
                style="padding-right:12px;"
                @click="toggleRibbon"
                v-tooltip="{content: toggleRibbonTooltip || ''}"
            ></span>
            <span
                class="screen-size-icon fal fa-square-full"
                @click="screenOptionsClick"
                v-tooltip="{content: 'Screen Options'}"

            ></span>
          <!--
          <span
              class="screen-size-icon screen-size-icon-first far fa-eye-slash"
              style=""
              @click="hideHeader"
              v-tooltip="{content: 'Hide Header'}"

          ></span>
          -->
            <!-- <span
                class="screen-size-icon far fa-window-minimize"
                @click="minimizeClicked"
            ></span> -->
          <span
              class="screen-size-icon screen-size-icon-first fas fa-times"
              style="color: red;"
              @click="closeClicked"
              v-tooltip="{content: 'Close'}"

          ></span>

        </span>
    </div>
   <oxygen-ribbon ref="screenRibbon" v-show="showScreenRibbon"></oxygen-ribbon>
   <oxygen-ribbon ref="headerRibbon" v-show="showHeaderRibbon"></oxygen-ribbon>

   <left-menu
       ref="leftMenu"
       :ClientID="ClientID"
       :viewportID="viewportID"
       :header-ribbon="headerRibbon"
       :context-p-e="contextPE"
   ></left-menu>
   <right-menu
       ref="rightMenu"
       :viewportID="viewportID"
   ></right-menu>

   <menu-modal
       ref="roleModal"
       :table-data="rolesTableData"
       :modal-name="roleModalName"
       :panel-title="roleModalTitle"
       :menu-items="roles"
       :styles="roleModalStyles"
   />
   <p-e-details
       :detailsData="detailsData"
       ref="detailsContainer"
       :subjectRoleChange="subjectRoleChange"

   ></p-e-details>
   <form-container
    :title="formContainerTitle"
    :form-rows="formRows"
    ref="formContainer"
   ></form-container>
   <!--
   <scheduler-container
       :title="schedulerContainerTitle"
       :defaultViewArgs="defaultViewArgs"
       @calendar-event-created="calendarEventCreated"
       ref="schedulerContainer"
       :show-button-ribbon="showSchedulerButtonRibbon"
       :tab-buttons="schedulerButtons"
   ></scheduler-container>
   -->
 </span>
  <options-menu
      :title="menuTitle"
      :container-name="menuName"
      :options="generalOptions"
      :table-params="menuTableParams"
      :show-checkbox="showOptionsMenuCheckbox"
      :show-folder="showOptionsMenuFolder"
      ref="generalOptionsMenu"

  ></options-menu>

  <options-menu
      :title="optionsMenuTitle"
      :container-name="optionsMenuName"
      :options="menuOptions"
      :table-params="optionsMenuTableParams"
      :show-checkbox="showOptionsMenuCheckbox"
      :show-folder="showOptionsMenuFolder"
      :right-aligned="rightAlignedOptionsMenu"
      :font-size="optionsMenuFontSize"
      :show-title="showOptionsMenuTitle"
      :width="optionsMenuWidth"
      :initial-limit="optionsMenuLimit"
      :container-hidden="optionsMenuHidden"
      ref="optionsMenu"
  ></options-menu>
<!--
  <availability-form ref="availabilityForm" :client="client"></availability-form>

  <appointment-form ref="appointmentForm" :client="client"></appointment-form>

  <appointments-list ref="appointmentsList" :client="client"></appointments-list>
  -->
  <future-history-form-container
      title="Future History"
      :viewport-i-d="viewportID"
      :client-i-d="ClientID"
      ref="historyForm"
  ></future-history-form-container>
  <!--
  <dialogue-creator-container
      :viewport-i-d="viewportID"
      :client-i-d="ClientID"
      :init-component-id="client.ClientRight"
      title="Root Prompt Creator"
      ref="dialogueCreator"
  ></dialogue-creator-container>
  -->
  <div v-show="!showHeader && headerHidden" style="display:inline-block; width:100%">
    <oxygen-ribbon ref="hiddenRibbon"></oxygen-ribbon>
  </div>
  <child-container
      :container-name="alertContainerName"
      :container-title="alertContainerTitle"
      :width="alertContainerWidth"
      ref="alertContainer"

  >
    <div style="color:black; padding: 15px;">{{alertContainerMessage}}</div>
  </child-container>
</template>

<script setup>
  import { ref, reactive, onMounted, watch, getCurrentInstance, nextTick } from 'vue';
  import * as async from 'async-es';
  //import { deviceStore } from './../../../stores/deviceStore';
  import OxygenRibbon from './../OxygenRibbon/OxygenRibbon.vue';
  import LeftMenu from './../LeftMenu/LeftMenu.vue';
  import RightMenu from './../RightMenu/RightMenu.vue';
  import * as oxygenUtil from "./../OxygenUtil";
  import MenuModal from './../MenuModal/MenuModal.vue';
  import PEDetails from './../PEDetails/PEDetails.vue';
  import FormContainer from './../FormContainer/FormContainer.vue';
  import SchedulerContainer from './../SchedulerContainer/SchedulerContainer.vue';
  import OptionsMenu from './../OptionsMenu/OptionsMenu.vue';
  import AvailabilityForm from './../AvailabilityForm/AvailabilityForm.vue';
  import AppointmentForm from './../AppointmentForm/AppointmentForm.vue';
  import AppointmentsList from './../AppointmentsList/AppointmentsList.vue';
  import { vTooltip } from 'floating-vue';
  import FutureHistoryFormContainer from './../FutureHistoryFormContainer/FutureHistoryFormContainer.vue';
  import ChildContainer from './../ChildContainer/ChildContainer.vue';
  import DialogueCreatorContainer from './../DialogueCreatorContainer/DialogueCreatorContainer.vue';
  import {
    getRecentlyOpenedClient,
    recordAnalyticsEvent,
    setupViewportComponentFnCallReturnListener
  } from "./../OxygenUtil";


  const props = defineProps({
    viewportID: {
      type: Number
    },
    ClientID: {
      type: Number
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  });

  let showHeader = ref(true),
      showTopHeader = ref(true),
      showPanelIndexNum = ref(true),
      parentIndex = ref(0),
      localIndex = ref(0),
      showThreadSubjectTitle = ref(true),
      simpleTitle= ref(""),
      showThread = ref(true),
      viewport = reactive({}),
      showHeaderRibbon = ref(false),
      showScreenRibbon = ref(false),
      headerRibbon = ref(null),
      hiddenRibbon = ref(null),
      screenRibbon = ref(null),
      rootMenuItem = reactive({}),
      rightMenu = ref(null),
      client = ref({}),
      PEDetailsOpenPEMode = ref(true),
      showSchedulerButtonRibbon = ref(true),
      availabilityForm = ref(null),
      appointmentForm = ref(null),
      appointmentsList = ref(null),
      historyForm = ref(null);

  //const store = deviceStore();


  const store = window.devStore;

  const list = reactive([
    { id: 1},
    {id: 2}
  ]);

  let headerHidden = ref(false);
  function hideHeader() {
    headerHidden.value = true;
    showHeader.value = false;
  }

  function restoreHeader() {
    headerHidden.value = false;
    showHeader.value = true;
  }

  let storeViewport = ref({});
  function setViewport (viewportID){
    storeViewport.value = store.viewPorts.find(e => (e.viewportID === viewportID) );
    Object.assign(viewport, storeViewport.value);
  }

  let clientContext = ref({}), clientReactive;
  function setClient(ClientID) {
    //console.log('Clients:', window.botStore.clients);
    //Object.assign(client, window.devStore.clients.find(e => (e.Client === ClientID)));
    client.value = window.devStore.clients.find(e => (e.Client === ClientID));
    clientReactive = reactive(window.devStore.clients.find(e => (e.Client === ClientID)));
    client.value.contactsMode = client.value.contactsMode || 'all';
    clientContext.value = JSON.parse(client.value.ClientContext);
    //console.log('Client:', client);
  }

  function setRootMenuItem(ClientID, viewportID) {
    Object.assign(rootMenuItem, window.devStore.rootMenu.find(e => (e.ClientRowID === ClientID && e.ViewPortID === viewportID)));
    setIndices();
    //console.log('rootMenuItem:', rootMenuItem);
  }

  let detailsIcon = ref(null), detailsData = ref({}), detailsContainer = ref(null), roleTokens;

  async function displayDetails() {
    let roles = await getRoles(), componentEdge, LeftDN, RightDN;
    await async.parallel([
        async () => {
          componentEdge = await oxygenUtil.getComponent(client.value.ClientLeft, client.value.ClientRight);
        },
        async () => {
          LeftDN = await oxygenUtil.getGDN(client.value.ClientLeft)
        },
        async () => {
          RightDN = await oxygenUtil.getGDN(client.value.ClientRight)
        }
    ]);
    roleTokens = componentEdge.RoleTokens;
    detailsData.value = Object.assign({}, rootMenuItem, { LeftDN, RightDN, SelectedLeftDN: rootMenuItem.LeftDN, SelectedRightDN: rootMenuItem.RightDN  },
        { SelectedRightRole: rootMenuItem.RightRole, RightRole: roles.map(e => e.role)});
    detailsContainer.value.showContainerAlignedToElementInViewport(detailsIcon.value, 'bottom', headerContainer.value.getBoundingClientRect());
  }

  async function getRoles() {
    let allRoles = ['owner','admin'].includes(client.value.ClientRightRole) ? await oxygenUtil.getAllComponentsRoles(
        [
          {
            id: client.value.ClientRight,
            defaultRole: client.value.ClientRightRole
          }
        ],
        [],
        [].concat(client.value.ClientRight === 'admin' ? 'owner' : [])) :
        await oxygenUtil.getAvailableComponentsRoles(
            [
              {
                id: client.value.ClientRight,
                defaultRole: client.value.ClientRightRole
              }
            ],
            clientContext.value.ToRightID,
            clientContext.value.ToRightR,
            [],
            []
        );
    return allRoles[client.value.ClientRight];
  }

  function subjectRoleChange(newRole) {
    let token;
    detailsContainer.value.hide();
    if(roleTokens && roleTokens[client.value.ClientLeftRole] && (token = roleTokens[client.value.ClientLeftRole][newRole])) {
      showRoleTokenForm(token, newRole);
    }
    else {
      window.oxygenUtil.pullPE(
          {
            ByClientID : client.value.Client,
            InitialContext : {
              ByClientID : client.value.Client
            },
            OpenPE : oxygenUtil.createSimpleOES(
                [client.value.ClientLeftRole, client.value.ClientLeft, newRole, client.value.ClientRight])
          }
      );
    }
  }

  async function showRoleTokenForm(token, newRole) {
    formContainerTitle.value = 'Enter Role Token';
    formRows.value = [

      {
        type: "input",
        name: "token",
        label: "Enter Role Token",
        value: '',
        placeholder: 'Please enter a 6-digit code',
        errorMessage: 'Invalid Token',
        validation: (value)=>{
         return token === value;
        }
      },
      {
        type: "button",
        css: "spaced-button",
        name: "submit",
        text: "Submit",
        size: "medium",
        view: "flat",
        color: "primary"
      }
    ];

    formContainer.value.showContainerAlignedToElementInViewport(
        document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
        'bottom',
        document.getElementById(props.viewportID).getBoundingClientRect()
    );

    await nextTick();
    formContainer.value.formInstance.getItem("submit").events.on("click", async ()=>{
      if(token === formContainer.value.formInstance.getItem("token").getValue()) {
        formContainer.value.hide();
        window.BotServices.PullPE(
            {
              ByClientID : client.value.Client,
              InitialContext : {
                ByClientID : client.value.Client
              },
              OpenPE : oxygenUtil.createSimpleOES(
                  [client.value.ClientLeftRole, client.value.ClientLeft, newRole, client.value.ClientRight])
            }
        );

      }

    });
  }

  watch(
      store.viewPorts,
      ()=> {
        //console.log('store.viewPorts-watch');
        setViewport(props.viewportID);
        if(props.ClientID !== props.viewportID) {
          setClient(viewport.ClientID);
          setRootMenuItem(viewport.ClientID, props.viewportID);
        }
        //rightMenu.value.setRightMenuOptions();
      },
      {
        deep: true
      }
  );



  function sendContactsModeChangeEvent() {
    oxygenUtil.dispatchClientEvent(client.value.Client, props.viewportID, 'contactsMode-change', { CurrentMode: client.value.contactsMode });
  }

  function addContactsModeChangeEventListener() {

    oxygenUtil.addClientEventListener(client.value.Client, 'contactsMode-change', (ev)=>{
      if((ev.detail.ViewportID !== props.viewportID) && headerRibbon.value ){
        headerRibbon.value.updateIconInfo('contact_mode', modeOptions.find(e => e.title.toLowerCase() === ev.detail.CurrentMode).icon);
      }
    });
  }

  function setClientsAPI() {
    //console.log('setting clientsAPI');
    if(!window.clientsAPI) {
      window.clientsAPI = {};
    }
    if(!window.clientsAPI[client.value.Client]) {
      window.clientsAPI[client.value.Client] = {};
    }

    if(!window.clientsAPI[client.value.Client].setContactsMode) {
      window.clientsAPI[client.value.Client].setContactsMode = (mode) => {
        client.value.contactsMode = mode;
        sendContactsModeChangeEvent();
        headerRibbon.value.updateIconInfo('contact_mode', iconMap[mode]);
      };

    }
  }

  let allModeIconInfo = { type: 'html',
    html: `<span title="All" class="far fa-address-book"></span>` },
  liveModeIconInfo = { type: 'html',
    html: `<span title="Live" style="color: green;" class="far fa-address-book"></span>` },
  meetingModeIconInfo = { type: 'html',
    html: `<span title="Meeting" style="color: red;" class="far fa-address-book"></span>` },
      openContactsIconInfo = { type: 'html',
        html: `<span title="Open Contacts" class="far fa-address-book"></span>` };
  const leftMenu = ref(null);

  let iconMap = {
    'all': allModeIconInfo,
    'live': liveModeIconInfo,
    'meeting': meetingModeIconInfo
  }


  const menuTitle = ref('Contacts'), generalOptionsMenu = ref(), menuName = ref(`id${oxygenUtil.getUUID()}`), generalOptions = ref([]),
      modeOptions = [
    {
      icon: openContactsIconInfo,
      title: 'Open Contacts',
      tooltip: 'Open Contacts',
      callback: ()=>{
        window.clientsAPI[client.value.Client].childViewports.showContacts();

        generalOptionsMenu.value.hideMenu();
      },
      path: `00001`
    },
    {
      icon: allModeIconInfo,
      title: 'All',
      tooltip: 'All',
      callback: ()=>{
        window.clientsAPI[client.value.Client].setContactsMode('all');

        generalOptionsMenu.value.hideMenu();
      },
      path: `00002`
    },
    {
      icon: liveModeIconInfo,
      title: 'Live',
      tooltip: 'Live',
      callback: ()=>{
        window.clientsAPI[client.value.Client].setContactsMode('live');

        generalOptionsMenu.value.hideMenu();
      },
      path: `00003`
    },
    {
      icon: meetingModeIconInfo,
      title: 'Meeting',
      tooltip: 'Meeting',
      callback: ()=>{
        window.clientsAPI[client.value.Client].setContactsMode('meeting');

        generalOptionsMenu.value.hideMenu();
      },
      path: `00004`
    }
  ],
      menuTableParams = reactive({
    showCheckbox: false,
    showFolder: false,
    showRightMenu: false,
    hideCheckboxCol: true
  }),
      searchOptions = [
        {
          icon: { type: 'html',  html: `<span title="Live" style="color:green;" class="far fa-search"></span>` },
          title: 'Live',
          tooltip: 'Live',
          callback: ()=>{
            oxygenUtil.dispatchViewportEvent(props.viewportID, 'search-time-mode-change', { SearchMode: 'live'});
            generalOptionsMenu.value.hideMenu();
          },
          path: `00001`
        },
        {
          icon: { type: 'html', html: `<span title="Future" style="color:#0072c5;" class="far fa-search"></span>` },
          title: 'Future',
          tooltip: 'Future',
          callback: ()=>{
            oxygenUtil.dispatchViewportEvent(props.viewportID, 'search-time-mode-change', { SearchMode: 'future'});
            generalOptionsMenu.value.hideMenu();
          },
          path: `00002`
        },
        {
          icon: { type: 'html', html: `<span title="Past" style="color:rgba(0, 0, 0, 0.5);" class="far fa-search"></span>` },
          title: 'Past',
          tooltip: 'Past',
          callback: ()=>{
            oxygenUtil.dispatchViewportEvent(props.viewportID, 'search-time-mode-change', { SearchMode: 'past'});
            generalOptionsMenu.value.hideMenu();
          },
          path: `00003`
        },
        {
          icon: { type: 'html', html: `<span title="All" class="far fa-search"></span>` },
          title: 'All',
          tooltip: 'All',
          callback: ()=>{
            oxygenUtil.dispatchViewportEvent(props.viewportID, 'search-time-mode-change', { SearchMode: 'all'});
            generalOptionsMenu.value.hideMenu();
          },
          path: `00004`
        }
      ];

  let headerRibbonIcons;
  function setRibbonIcons() {
    headerRibbonIcons = reactive([
      {
        id: "left_menu",
        iconInfo: { type: "css", classes: "far fa-ellipsis-v"},
        callback: ()=>{
          leftMenu.value.showMenu(headerRibbon.value.getIconElement('left_menu'));
        },
        orientation: 'left',
        toolTip: "UI Options"
      },
      {
        id: "thread_subject",
        iconInfo: { type: 'html',
          html: `<span class="icon-thread16-simplia"></span>` },
        callback: ()=>{
          let rootMenuItem = window.devStore.rootMenu.find(e => e.ViewPortID === oxygenUtil.getMainViewportIDFromClient(client.value.Client));
          console.log('open-main-panel-callback', 'rootMenuItem:', rootMenuItem);
          //window.BotServices.PullRootMenu(rootMenuItem);
          //window.BotServices.ActiveViewport(rootMenuItem.ViewPortID);
          window.oxygenUtil.putViewportOnTop(rootMenuItem.ViewPortID);
        },
        orientation: 'left',
        toolTip: "Open Main Panel"
      },
      {
        id: "desk_mode",
        iconInfo: { type: 'html',
          html: `<span class="far fa-circle-nodes fa-rotate-by" style="--fa-rotate-angle: 80deg;"></span>` },
        callback: async (item, ev)=>{
          await toggleDeskMode();
        },
        orientation: 'left',
        toolTip: "Enable Stage Mode"
      },
      {
        id: "contact_mode",
        iconInfo: Object.assign({}, modeOptions.find(e => e.title.toLowerCase() === (client.value.contactsMode)).icon),
        callback: ()=>{
          generalOptions.value = modeOptions;
          menuTitle.value = 'Contacts';
          generalOptionsMenu.value.showMenuAlignedToElement(headerRibbon.value.getIconElement('contact_mode'), 'left', 'bottom');
        },
        orientation: 'left',
        toolTip: "Contacts"
      },
      {
        id: "search",
        iconInfo: { type: "css", classes: "far fa-search"},
        callback: ()=>{
          generalOptions.value = searchOptions;
          menuTitle.value = 'Search';
          generalOptionsMenu.value.showMenuAlignedToElement(headerRibbon.value.getIconElement('search'), 'left', 'bottom');
          toggleSearch(true);
        },
        orientation: 'left',
        toolTip: "Enable Search",
        show: false
      },
      {
        id: "right_menu",
        iconInfo: { type: "css", classes: "far fa-ellipsis-v"},
        callback: ()=>{

          rightMenu.value.showMenu(headerRibbon.value.getIconElement('right_menu'), 'right');
        },
        orientation: 'right',
        toolTip: "All Actions"
      },
      {
        id: "expand",
        iconInfo: { type: "css", classes: "far fa-angle-double-down"},
        callback: (item, ev)=>{
          toggleHeaderRibbon();
        },
        orientation: 'right',
        toolTip: "Expand"
      },
      {
        id: "show_help",
        iconInfo: { type: "css", classes: "fal fa-question-circle"},
        callback: ()=>{

        },
        orientation: 'right',
        toolTip: "Show Help"
      }
    ]);
  }

  function toggleHeaderRibbon(val) {
    let item = headerRibbon.value.getIcon("expand");
    if((!item.expanded && (typeof val === "undefined") )|| val) {
      item.expanded = true;
      headerRibbon.value.expandRibbon();
      headerRibbon.value.updateIconInfo('expand', { type: "css", classes: "far fa-angle-double-up"});
      headerRibbon.value.updateIconAttributes('expand', { tooltip: 'Collapse'});
    }
    else {
      item.expanded = false;
      headerRibbon.value.collapseRibbon();
      headerRibbon.value.updateIconInfo('expand', { type: "css", classes: "far fa-angle-double-down"});
      headerRibbon.value.updateIconAttributes('expand', { tooltip: 'Expand'});
    }

  }

  let deskModeIconsAdded;
  async function enableDeskMode() {
    emit('desk-mode-toggled', props.viewportID, true);
    if(!deskModeIconsAdded) {
      deskModeIconsAdded = true;
      headerRibbon.value.addRibbonIcons(leftMenu.value.deskModeIcons.reverse());
    }
    else {
      leftMenu.value.deskModeIcons.forEach((e)=> headerRibbon.value.showRibbonIcon(e.id));
    }
    await nextTick();
    toggleHeaderRibbon(true);

  }

  function disableDeskMode() {
    emit('desk-mode-toggled', props.viewportID, false);
    leftMenu.value.deskModeIcons.forEach((e)=> headerRibbon.value.hideRibbonIcon(e.id));
    toggleHeaderRibbon(false);
  }

  let hiddenRibbonIcons, optionsShown = ref(false);
  watch(
      optionsShown,
      (newVal)=>{
        console.log('optionsShown-watch', 'new val:', newVal);
        if(newVal) {
          addOptionsMenuOptions();
          optionsMenu.value.showMenuAlignedToElement(hiddenRibbon.value.getIconElement('restore'), 'right', 'bottom', '', 0, -30);
          //hiddenRibbon.value.updateIconInfo('restore', { type: "css", classes: "fas fa-times", color: 'red', style: { 'padding-right': '6px' }})
          //hiddenRibbon.value.hideRibbonIcon('restore');

        }
        else {
          optionsMenu.value.hideMenu();
          //hiddenRibbon.value.showRibbonIcon('restore');
          //hiddenRibbon.value.updateIconInfo('restore', { type: "css", classes: "far fa-bars", color: '#0072C5', style: { 'padding-right': '6px' }})
        }
      }
  );

  function optionsMenuHidden() {
    optionsShown.value = false;
  }

  function setHiddenRibbonIcons() {
    hiddenRibbonIcons = reactive([
      {
        id: "restore",
        iconInfo: { type: "css", classes: "far fa-bars", color: '#0072C5', style: { 'padding-right': '6px' }},
        callback: ()=>{
          optionsShown.value = !optionsShown.value;
          console.log('restore-clicked', 'new val:', optionsShown.value);
        },
        orientation: 'right',
        toolTip: "Options"
      },
    ]);
  }

  let searchMode = ref(false);
  function toggleSearch(value) {
    if(typeof value !== "undefined") {
      searchMode.value = value;
    }
    else {
      searchMode.value = !searchMode.value;
    }


    window.top.oxygenUtil.dispatchViewportEvent(props.viewportID, 'toggle-search', { SearchMode: searchMode.value });
  }

  const screenRibbonIcons = reactive([
    {
      id: "hide",
      iconInfo: { type: "css", classes: "fas fa-times"},
      callback: ()=>{
        showHeaderRibbon.value = lastHeaderRibbonState;
        showScreenRibbon.value = false;

      },
      orientation: 'right',
      toolTip: "Hide the Toolbar"
    },
    {
      id: "expand",
      iconInfo: { type: "css", classes: "far fa-angle-double-down "},
      callback: ()=>{

      },
      orientation: 'right',
      toolTip: "Expand"
    },
    /*{
      id: "enlarge_font",
      iconInfo: { type: "css", classes: "far fa-font enlarge-font-icon"},
      callback: ()=>{

      },
      orientation: 'right',
      toolTip: "Enlarge Font Size"
    },
    {
      id: "reduce_font",
      iconInfo: { type: "css", classes: "far fa-font reduce-font-icon"},
      callback: ()=>{

      },
      orientation: 'right',
      toolTip: "Reduce Font Size"
    },*/
    {
      id: "full_screen",
      iconInfo: { type: "css", classes: "fal fa-expand-wide "},
      callback: setFullScreen,
      orientation: 'right',
      toolTip: "Full screen Mode"
    },
    {
      id: "desktop",
      iconInfo: { type: "css", classes: "far fa-desktop-alt "},
      callback: setDesktopMode,
      orientation: 'right',
      toolTip: "Desktop Mode"
    },
    {
      id: "laptop",
      iconInfo: { type: "css", classes: "far fa-laptop "},
      callback: setLaptopMode,
      orientation: 'right',
      toolTip: "Laptop Mode"
    },
    {
      id: "tablet",
      iconInfo: { type: "css", classes: "fas fa-tablet-alt "},
      callback: setTabletMode,
      orientation: 'right',
      toolTip: "Tablet Mode"
    },
    {
      id: "mobile",
      iconInfo: { type: "css", classes: "fas fa-mobile-alt "},
      callback: setMobileMode,
      orientation: 'right',
      toolTip: "Mobile Mode"
    }/*,
    {
      id: "settings",
      iconInfo: { type: "css", classes: "fat fa-gears "},
      callback: showUISettings,
      orientation: 'right',
      toolTip: "UI Settings"
    }*/
  ]);

  const headerContainer = ref(null);
  function setFullScreen() {
    //window.headerContainer = headerContainer;
    let terminationElement = headerContainer.value.closest('div[name="oxygen-viewport"]').querySelector('div[name="oxygen-termination"]');
    requestFullScreen(terminationElement);
  }

  function requestFullScreen(docElm) {
    //console.log('requestFullScreen', 'docElm:', docElm, ' - reqFullScr:', docElm.requestFullscreen);
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    }
    else {
      //console.log('requestFullScreen', 'returning false');
      return false;
    }
    //console.log('requestFullScreen', 'returning true');
    return true;
  }

  function setDesktopMode() {
    storeViewport.value.Width = '100%';
    oxygenUtil.sendViewportChangeEvent(props.viewportID,{Width: '100%', Mode: 'Desktop'});
  }

  function setLaptopMode() {
    storeViewport.value.Width = '1264px';
    oxygenUtil.sendViewportChangeEvent(props.viewportID,{Width: '1264px', Mode: 'Laptop'});
  }

  function setTabletMode() {
    storeViewport.value.Width = '769px';
    oxygenUtil.sendViewportChangeEvent(props.viewportID,{Width: '769px', Mode: 'Tablet'});
  }

  function setMobileMode() {
    storeViewport.value.Width = '415px';
    oxygenUtil.sendViewportChangeEvent(props.viewportID,{Width: '415px', Mode: 'Mobile'});
  }

  let attributionRecord;
  onMounted(async ()=>{

    //console.log('viewportHeader-onMounted', 'viewportID:', props.viewportID, ' - clientID:', props.ClientID );
    storeViewport.value.leftMenu = leftMenu.value;
    //window.viewportHeader = getCurrentInstance();

    setViewport(props.viewportID);
    setClient(props.ClientID);

    setRootMenuItem(props.ClientID, props.viewportID);
    setRibbonIcons();
    setHiddenRibbonIcons();
    headerRibbon.value.addRibbonIcons(headerRibbonIcons);
    screenRibbon.value.addRibbonIcons(screenRibbonIcons);
    hiddenRibbon.value.addRibbonIcons(hiddenRibbonIcons);
    addContactsModeChangeEventListener();
    setStoreWatch();
    storeViewport.value.headerRibbon = headerRibbon;
    storeViewport.value.formContainer = {
      formContainer,
      formRows,
      formContainerTitle
    };
    contextPE.value = getContextPE();
    //storeViewport.value.header = getCurrentInstance();
    //setRightMenu();

    let viewportElement = headerContainer.value.closest('div[name="oxygen-viewport"]');
    viewportElement.tabIndex = -1;

    oxygenUtil.setHistoryData(client.value);
    oxygenUtil.setupClientEventsListeners(viewportElement, client.value);

    /*
    onVisible(viewportElement, ()=>{
      viewportElement.focus();
    });

     */
    addRightMenuOptions();
    if(client.value.Attribution) {
      attributionRecord = await oxygenUtil.getAttributionRecord(client.value.Attribution);
    }

    window.top.oxygenUtil.setupViewportComponentFnCallReturnListener(props.viewportID, 'viewport-header', {
      hideHeader,
      restoreHeader,
      setView,
      toggleSearch,
      toggleDeskMode,
      setActiveClient,
      setActiveViewport,
      showAlertContainer,
      toggleRibbon
    });
    setActiveViewport();
    setClientsAPI();
  });

  function setActiveViewport() {
    window.devStore.setActiveViewportId(props.viewportID);
  }

  function setActiveClient(client) {
    console.log('setActiveClient', 'client:', client);
    window.devStore.setActiveClient(client);
  }

  function setView(view) {
    leftMenu.value.setView(view);
  }

  function setIndices() {
    parentIndex.value = rootMenuItem.ParentIndex;
    localIndex.value = rootMenuItem.LocalIndex;
  }

  const rightMenuOptions = reactive([
    {icon: 'far fa-inbox-in', title: 'Test', callback: (e)=>{
      addRightMenuOption();
      //console.log(e);
    }}
  ]);



  function onVisible(element, callback) {
    new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          callback(element);
          observer.disconnect();
        }
      });
    }).observe(element);
  }

  function addRightMenuOption() {
    let currentCount = storeViewport.value.rightMenu.length;
    storeViewport.value.rightMenu.push({icon: 'far fa-inbox-in', title: `Test ${currentCount + 1}`, callback: (e)=>{
      addRightMenuOption();
        //console.log(e);
    }});
  }

  function setRightMenu() {
    storeViewport.value.rightMenu = storeViewport.value.rightMenu || rightMenuOptions;
    watch(
        storeViewport.value.rightMenu,
        ()=>{
          //console.log('watch-RightMenuOptions');
          rightMenu.value.options.length = 0;
          rightMenu.value.options.push(...storeViewport.value.rightMenu.map((e, i)=>{
            return {
              icon: e.icon || '',
              title: e.title,
              callback: e.callback,
              path: `${(i + '').padStart(5,'0')}`
            }
          }));
        },
        {
          immediate: true
        }
    )
  }

  function setStoreWatch() {
    watch(
        storeViewport,
        ()=>{
          headerContainer.value.closest('div[name="oxygen-viewport"]').style['width'] = storeViewport.value.Width;
          headerContainer.value.closest('div[name="oxygen-viewport"]').style['height'] = storeViewport.value.Height;
        },
        {
          deep: true
        }
    );
  }

  function screenOptionsClick(){
    showHeaderRibbon.value = false;
    showScreenRibbon.value = true;
  }

  function minimizeClicked() {
    window.DevMgr.minimizeWindow(props.viewportID);
  }

  function homeIconClicked() {
    window.showRootMenu();
  }

  function closeClicked() {
    let segmentId = client.value.Client;
    window.oxygenUtil.recordAnalyticsEvent("PanelClose", { segmentId, segmentRootId: segmentId}, client.value.historyData);


    window.DevMgr.closeViewPort(props.viewportID)
  }

  let roleModal = ref(null),
      roleModalName = ref('roleModal'),
      roleModalTitle = ref('Role'),
      roles = reactive([]),
      rolesTableData = reactive({
        showCheckbox: false
      }),
      roleModalStyles = reactive({});

  function addRoles(newRoles) {
    roles.length = 0;
    newRoles.forEach((e) => {
      roles.push({
        title: oxygenUtil.capitalizeFirstLetter(e),
        showCheckbox: true,
        selected: true
      })
    });
  }

  function threadRoleClicked(event) {
    addRoles([rootMenuItem.LeftRole]);
    //roleModal.value.showModalAlignedToElement(event.path[0], 'left', 'bottom');
  }

  function subjectRoleClicked(event) {
    addRoles([rootMenuItem.RightRole]);
    //roleModal.value.showModalAlignedToElement(event.path[0], 'left', 'bottom');
  }

  function addSavePDFOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-file-pdf`,
      title: 'Save As PDF',
      callback: async (rightMenuItem)=> {
        formContainerTitle.value = 'PDF Options ';
        formRows.value = [
          {
            type: "select",
            name: "template",
            label: "Template",

            options:[
              { value: '_FF10313609901216306869076411514878_', content: 'PlateTestTemplate'}
            ],
            value: '_FF10313609901216306869076411514878_'
          },
          {
            id: "documentHeight",
            name: "documentHeight",
            type: "radioGroup",
            required: true,
            labelPosition: "top",
            value: "entire",
            options: {
              rows: [
                {
                  type: "radioButton",
                  text: "Entire Document",
                  value: "entire",
                },
                {
                  type: "radioButton",
                  text: "Visible Document",
                  value: "visible"
                },
              ]
            }
          },
          {
            type: "input",
            name: "saveAsName",
            label: "Save As",
            value: client.value.ClientRightDN
          },
          /*{
            type: "input",
            label: 'Email',
            name: 'email'
          },*/
          {
            type: "button",
            css: "spaced-button",
            name: "saveAsPDF",
            text: "Save As PDF",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();
        //console.log('saveAsPDF-callback', 'formContainer:', formContainer);
        window._formContainer = formContainer.value;
        formContainer.value.formInstance.getItem("saveAsPDF").events.on("click", async ()=>{
          //formInstance.getItem("email").getValue()
          //console.log('saveAsPDF-callback');
          //await postEmailPDFHistoryTask();
          let component = await makePDF(formContainer.value.formInstance.getItem("saveAsName").getValue(), formContainer.value.formInstance.getItem("documentHeight").getValue() == "entire");
          formContainer.value.hide();
          window.BotServices.PullPE(
              {
                ByClientID : client.value.Client,
                InitialContext : {
                  ByCLientID: client.value.Client
                },
                OpenPE : component.grants.adminGrant.GrantPE
              }
          );
        });
      }

    });
  }

  function addEmailSettingsOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-envelope`,
      title: 'Email Settings',
      callback: async (rightMenuItem)=> {
        let rows = await oxygenUtil.runDBQuery(
            `select * from OxygenDatabase.EmailScreeningTemplates where LocalPE = ?`,
            [ getContextPE() ]
        );

        let existingSettings = {}, templateParams = {};
        if(rows.length) {
          existingSettings = rows[0];
          templateParams = JSON.parse(existingSettings.ScreeningTemplateParams);
        }

        formContainerTitle.value = 'Email Screening Options';
        formRows.value = [
          {
            type: "input",
            name: "Email",
            label: "Email",
            value: existingSettings.Email || ''
          },
          {
            type: "input",
            name: "EmailScreeningSubject",
            label: "Email Screening Subject",
            value: templateParams.EmailScreeningSubject || ''
          },
          {
            type: "button",
            css: "spaced-button",
            name: "save",
            text: "Save",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();

        window._formContainer = formContainer.value;
        formContainer.value.formInstance.getItem("save").events.on("click", async ()=>{
          let screeningParams = JSON.stringify({
            EmailScreeningSubject: formContainer.value.formInstance.getItem("EmailScreeningSubject").getValue()
          })
          await oxygenUtil.runDBQuery(
              !rows.length ?
                  `insert into OxygenDatabase.EmailScreeningTemplates (ScreeningTemplate, ScreeningTemplateDN, ScreeningTemplateParams, ScreeningTemplateFilepath, LocalEmail, LocalPE ) values (?, ?, ?, ?, ?)` :
                  `update OxygenDatabase.EmailScreening set ScreeningTemplate = ?, ScreeningTemplateDN = ?, ScreeningTemplateParams, ScreeningTemplateFilepath = ?, LocalEmail = ? where LocalPE = ?`,
              [
                  '_FFFFFFFFFFFFFF00001727313055626596_',
                'EmailScreeningTemplate-0055',
                screeningParams,
                '/Code/github/SimpliaV2Components/EmailScreeningTemplates/EmailScreeningTemplate-0055/main.js',
                formContainer.value.formInstance.getItem("Email").getValue(),
                getContextPE()
              ]
          );

          formContainer.value.hide();
        });
      }

    })
  }

  function addEmailSettingsOptionOld() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-envelope`,
      title: 'Email Settings',
      callback: async (rightMenuItem)=> {
        let rows = await oxygenUtil.runDBQuery(
            `select er.LinkedEmail, er.ForeignEmailDomain, er.LinkedEmail,
es.ForeignEmailDomain as ScreeningForeignEmailDomain, es.LocalPE, es.ReplyTemplate, es.TemplateText
from OxygenDatabase.EmailRedirector er, OxygenDatabase.EmailScreening es
where er.LocalPE = ?
and er.LocalPE = es.LocalPE`,
            [ getContextPE() ]
        );

        let existingSettings = {};
        if(rows.length) {
          existingSettings = rows[0];
        }

        formContainerTitle.value = 'Email Redirection Options';
        formRows.value = [
          {
            type: "input",
            name: "LinkedEmail",
            label: "Linked Email",
            value: existingSettings.LinkedEmail || ''
          },
          /*{
            type: "checkbox",
            name: "SkipNotification",
            label: "Skip Notification",
            value: (typeof existingSettings.SkipNotification !== "undefined") ? existingSettings.SkipNotification : true
          },*/
          {
            type: "input",
            name: "ForeignEmailDomain",
            label: "External Service Mail Domain",
            value: existingSettings.ForeignEmailDomain || 'job.craigslist.org'
          },

          {
            type: "input",
            name: "Screening.ForeignEmailDomain",
            label: "Receiving Mail Domain",
            value: existingSettings.ScreeningForeignEmailDomain || 'reply.craigslist.org'
          },
          {
            type: "input",
            name: "ReplyTemplate",
            label: "Reply Email Template",
            value: existingSettings.ReplyTemplate || '_FFFFFFFFFFFFFF00001666165378437733_'
          },
          {
            type: "textarea",
            name: "TemplateText",
            label: "Reply Email Content",
            value: existingSettings.TemplateText || ''
          },

          {
            type: "button",
            css: "spaced-button",
            name: "save",
            text: "Save",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();

        window._formContainer = formContainer.value;
        formContainer.value.formInstance.getItem("save").events.on("click", async ()=>{
          //formInstance.getItem("email").getValue()
          //console.log('save-callback');
          //await postEmailPDFHistoryTask();
          await oxygenUtil.runDBQuery(
              !rows.length ? `insert into OxygenDatabase.EmailRedirector (LinkedEmail, ForeignEmailDomain, LocalPE ) values (?, ?, ?)` :
                  `update OxygenDatabase.EmailRedirector set LinkedEmail = ?, ForeignEmailDomain = ? where LocalPE = ?`,
              [formContainer.value.formInstance.getItem("LinkedEmail").getValue(), formContainer.value.formInstance.getItem("ForeignEmailDomain").getValue(), getContextPE()]
          );

          await oxygenUtil.runDBQuery(
              !rows.length ? `insert into OxygenDatabase.EmailScreening (ReplyTemplate, ForeignEmailDomain, TemplateText, LocalPE ) values (?, ?, ?, ?)` :
                  `update OxygenDatabase.EmailScreening set ReplyTemplate = ?, ForeignEmailDomain = ?, TemplateText = ? where LocalPE = ?`,
              [formContainer.value.formInstance.getItem("ReplyTemplate").getValue(), formContainer.value.formInstance.getItem("Screening.ForeignEmailDomain").getValue(), formContainer.value.formInstance.getItem("TemplateText").getValue(),getContextPE()]
          );
          if(!rows.length || existingSettings.LinkedEmail !== formContainer.value.formInstance.getItem("LinkedEmail").getValue()) {
            await oxygenUtil.callCommonServiceAPI(
                "simplia-api",
                'addTrackingRecord',
                {
                  relation: 'EmailToPE',
                  PE1: formContainer.value.formInstance.getItem("LinkedEmail").getValue(),
                  PE2: getContextPE(),
                  extraParams: {
                  }
                }
            );
          }
          formContainer.value.hide();
        });
      }

    })
  }

  function addDownloadFileOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
          icon: `fal fa-download`,
          title: 'Download File',
          callback: async (rightMenuItem) => {
            const anchor = document.createElement('a');
            let data = await oxygenUtil.callServerAPI(
                "getFileUrls",
                {
                  componentId: client.value.ClientRight,
                  sessionId: oxygenUtil.Cookies.get('sessionId')
                }
            );
            //console.log('getFileUrl', 'data');
            anchor.href = data.fileUrl;
            //anchor.href = await oxygenUtil.getComponentFileUrl(client.value.ClientRight);
            //console.log('Download File-callback', 'href:', anchor.href);
            let matches = /^.+\/(.+)$/.exec(anchor.href);
            anchor.download = matches[1];
            anchor.click()

          }
        }
    );
  }


  function addRoleTokenOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-key`,
      title: 'Set Role Tokens',
      callback: async (rightMenuItem)=> {
        let allRoles = await oxygenUtil.getAllComponentsRoles(
            [
              {
                id: client.value.ClientRight,
                defaultRole: client.value.ClientRightRole
              }
            ],
            [],
            ['owner'].concat(client.value.ClientRight !== 'owner' ? 'admin' : []));

        let componentEdge = await oxygenUtil.getComponent(client.value.ClientLeft, client.value.ClientRight);

        formContainerTitle.value = 'Set Role Tokens';
        formRows.value = [
          {
            type: "select",
            name: "roleName",
            label: "Role Name",

            options: [{ value: "", content: ""}].concat(allRoles[client.value.ClientRight].map((e)=>{
              return { value: e.role, content: e.role};
            })),
            value: ''
          },
          {
            type: "input",
            name: "token",
            label: "Role Token",
            value: '',
            placeholder: 'Please enter a 6-digit code',
            errorMessage: "Invalid token",
            validation: (value)=> {
              return /^[\d]{6}$/.test(value);
            }
          },
          {
            type: "button",
            css: "spaced-button",
            name: "add",
            text: "Add",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();
        formContainer.value.formInstance.getItem("roleName").events.on("change", async()=>{
          let currentRole = formContainer.value.formInstance.getItem("roleName").getValue();
          let tokenVal = componentEdge.RoleTokens && componentEdge.RoleTokens[client.value.ClientLeftRole] &&
              componentEdge.RoleTokens && componentEdge.RoleTokens[client.value.ClientLeftRole][currentRole] ?
              componentEdge.RoleTokens && componentEdge.RoleTokens[client.value.ClientLeftRole][currentRole] : "";
          formContainer.value.formInstance.getItem("token").setValue(tokenVal);

          formContainer.value.formInstance.getItem("add").setProperties({text: tokenVal ? 'Update' : 'Add'});

        });

        formContainer.value.formInstance.getItem("add").events.on("click", async ()=>{
          let roleName, token;
          //console.log('addRole-click', 'role:',  formContainer.value.formInstance.getItem("roleName").getValue());
          if((roleName = formContainer.value.formInstance.getItem("roleName").getValue()) &&
              (token = formContainer.value.formInstance.getItem("token").getValue())) {
            if(/^[\d]{6}$/.test(token)) {
              await oxygenUtil.updateComponentEx(
                  client.value.ClientLeft,
                  {
                    'set': Object.assign({}, componentEdge.RoleTokens ? {
                          [`RoleTokens.${client.value.ClientLeftRole}`] : Object.assign({},
                              (componentEdge.RoleTokens && componentEdge.RoleTokens[client.value.ClientLeftRole]) ?
                                  componentEdge.RoleTokens[client.value.ClientLeftRole] : {},
                              { [roleName] : token })
                        } :
                        {
                          'RoleTokens': {
                            [client.value.ClientLeftRole] : { [roleName] : token }
                          } }),
                    Edge: client.value.ClientRight
                  }
              );
              formContainer.value.hide();
            }
          }
        });
      }

    })
  }

  function addSetAvailabilityOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-calendar`,
      title: 'Set Availability',
      callback: async (rightMenuItem) => {
        availabilityForm.value.show();
      }
    });
  }

  function addChooseAppointmentOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-calendar`,
      title: 'Choose Appointment',
      callback: async (rightMenuItem) => {
        appointmentForm.value.show();
      }
    });
  }

  function addHistoryFormOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-clock-rotate-left`,
      title: 'Show History Form',
      callback: async (rightMenuItem) => {
        historyForm.value.show();
      }
    });
  }
  let dialogueCreator = ref(null);
  function addDialogueCreatorOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-microchip-ai`,
      title: 'Set Root Prompt',
      callback: async (rightMenuItem) => {
        dialogueCreator.value.show();
      }
    });
  }

  function addShowAppointmentsOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-calendar`,
      title: 'Show Appointments',
      callback: async (rightMenuItem) => {
        appointmentsList.value.show();
      }
    });
  }

  function addEditContextOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-pen-to-square`,
      title: 'Edit Context',
      callback: async (rightMenuItem)=> {
        let terminationUrl = {
          "MediaType": "Iframe",
          "URL": "/TemplateSchema/TemplateClient/index.html?componentid=" + client.value.ClientRight
        };
        window.BotServices.openChildPanel({
          ClientID: props.ClientID,
          DisplayName: 'Edit Context',
          Termination: terminationUrl
        }, () => {
        });
      }
    });
  }

  function addMeetworkSettingsOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-envelope`,
      title: 'Set Meetwork Email',
      callback: async (rightMenuItem)=> {
        let trackingRecord = await oxygenUtil.callCommonServiceAPI(
            'simplia-api',
            'getTrackingRecordByPE2',
            {
              relation: 'MeetworkEmailToPE',
              pe2: getContextPE(),
              singleRetValue: true
            }
        );
        console.log('addMeetworkSettingsOption', 'trackingRecord:', trackingRecord);


        formContainerTitle.value = 'Meetwork Email Settings';
        formRows.value = [
          {
            type: "input",
            name: "MeetworkEmail",
            label: "Meetwork Email",
            value: trackingRecord.PE1 || ''
          },

          {
            cols: [
              {
                type: "button",
                css: "spaced-button",
                name: "save",
                text: "Save",
                size: "medium",
                view: "flat",
                color: "primary",
                padding: 10
              }/*,
              {
                type: "button",
                css: "spaced-button",
                name: "sync",
                text: "Sync Mail",
                size: "medium",
                view: "flat",
                color: "primary",
                padding: 10
              }*/
            ]
          },
          {
            name: "beforedate",
            type: "datepicker",
            dateFormat: '%y/%m/%d',
            label: "Before Date"
          },
          /*{
            name: "beforetime",
            type: "timepicker",
            label: "Before Time",
            controls: true
          },*/
          {
            type: "button",
            css: "spaced-button",
            name: "sync",
            text: "Sync Mail",
            size: "medium",
            view: "flat",
            color: "primary",
            padding: 10
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();

        //window._formContainer = formContainer.value;
        formContainer.value.formInstance.getItem("save").events.on("click", async ()=>{
          let email = formContainer.value.formInstance.getItem("MeetworkEmail").getValue();
          console.log('MeetworkEmail-save', 'email:', email);
          if(oxygenUtil.isEmptyObject(trackingRecord) || (trackingRecord.PE1 !== email)) {
            let newTrackingRecord;
            await async.parallel([
                async () => {
                  newTrackingRecord = await oxygenUtil.callCommonServiceAPI(
                      "simplia-api",
                      'addTrackingRecord',
                      {
                        relation: 'MeetworkEmailToPE',
                        PE1: email,
                        PE2: getContextPE(),
                        extraParams: oxygenUtil.isEmptyObject(trackingRecord) ? {} : Object.fromEntries(Object.entries(trackingRecord).filter((e)=>{
                          return !["Node", "Edge", "UpdateTime", "PE1", "PE2", "Relation"].includes(e[0])
                        }))
                      }
                  );
                },
                async () => {
                  await oxygenUtil.callCommonServiceAPI(
                      "simplia-api",
                      'deleteTrackingRecord',
                      {
                        nodeId: trackingRecord.Node,
                        edge: trackingRecord.Edge
                      }
                  );
                },
              async () => {
                await oxygenUtil.callCommonServiceAPI(
                    "simplia-api",
                    'setupMeetworkEmailWatch',
                    {
                      email
                    }
                );
              },
              async () => {
                await oxygenUtil.callCommonServiceAPI(
                    "simplia-api",
                    'stopMeetworkEmailWatch',
                    {
                      email: trackingRecord.PE1
                    }
                );
              }
                /*
              async () => {
                await fetch(`/MeetworkGateway/System/ServerSide/watch/${email}`, { method: 'GET'});
              },
              async () => {
                await fetch(`/MeetworkGateway/System/ServerSide/stopwatch/${trackingRecord.PE1}`, { method: 'GET'});
              }
                 */
            ]);
            trackingRecord = newTrackingRecord;
          }

          formContainer.value.hide();
        });

        formContainer.value.formInstance.getItem("sync").events.on("click", async ()=>{
          let date = formContainer.value.formInstance.getItem("beforedate").getValue();
              //time = formContainer.value.formInstance.getItem("beforetime").getValue();

          if(!oxygenUtil.isEmptyObject(trackingRecord) && date) {
            //console.log('addMeetworkSettingsOption-sync-click', 'date:', date);

            let response = await oxygenUtil.callCommonServiceAPI(
                "simplia-api",
                'syncMeetworkAccountEmails',
                {
                  userId: trackingRecord.PE1,
                  timestamp: `20${date}`
                }
            );


          }
        });
      }
    });
  }

  function addNewEmailOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-at`,
      title: 'Add simplia.ai Email',
      callback: async (rightMenuItem)=> {


        //console.log('Update DisplayName', 'uuid:', uuid);
        formContainerTitle.value = 'Add simplia.ai Email';
        formRows.value = [
          {
            type: "input",
            name: "FirstName",
            label: "First Name",
            value:  'Email Display First Name',
            padding: "10px"
          },
          {
            type: "input",
            name: "LastName",
            label: "Last Name",
            value: 'Email Display Last Name',
            padding: "10px"
          },
          {
            type: "input",
            name: "email",
            label: "Email",
            value: '',
            placeholder: 'Email Address'
          },
          {
            type: "input",
            inputType: "password",
            name: "password",
            label: "Password",
            value: '',
            placeholder: 'Email Password'
          },
          {
            type: "input",
            name: "smartlink",
            label: "Smart Link",
            value: '',
            readOnly: true,
            placeholder: 'Inbox Smart Link'
          },
          {
            type: "button",
            css: "spaced-button",
            name: "create",
            text: "Create",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();




        formContainer.value.formInstance.getItem("create").events.on("click", async ()=>{
          let email = formContainer.value.formInstance.getItem("email").getValue();
          let emailInfo = await oxygenUtil.getEmailAddressInfo(email, formContainer.value.formInstance.getItem("password").getValue());
          let emailUsername = email.substring(0, email.indexOf("@"));
          let personalGatewayPE = oxygenUtil.parseOES(emailInfo.personalGatewayPE).segments;

          await oxygenUtil.runDBQuery(
              `update OxygenDatabase.Attribution set given_name = ?,
family_name = ? where ID = ?`,
              [ formContainer.value.formInstance.getItem("FirstName").getValue(),
                formContainer.value.formInstance.getItem("LastName").getValue(), emailInfo.attribution.ID]
          );

          let inboxTermination = {
            DisplayName : 'Inbox',
            Termination : {
              MediaType : 'WebComponent',
              URL: '/simplia/dist/builds/inbox-wc/app.js',
              Template: 'oxygen-inbox'
            }
          }, payload = {
            onLoad: [
              { signup: true }
            ],
            onLogin : [
              {
                open: true,
                role: personalGatewayPE[0],
                component : personalGatewayPE[1],
                child: inboxTermination
              }
            ]
          };

          const url = '/BotServices/bot/getSignedUrl';

          try {
            let req = await fetch(url, {
              method: 'POST',
              headers: {
                'content-type': 'application/json'
              },
              body: JSON.stringify({
                URL: `https://simplia.ai/DeviceManager/index.html?overlay=false`,
                Role: personalGatewayPE[0],
                Component: personalGatewayPE[1],
                InitialContext: payload,
                URLType: 'Label',
                URLLabel: emailUsername
              })
            });

            let res = await req.json();
            formContainer.value.formInstance.getItem("smartlink").setValue(res.ShortURL);
          }
          catch(e) {
            console.log('Error:', e);
          }
        });
      }
    })
  }

  function addEnableSessionBotOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `far fa-robot`,
      title: 'Enable Session Bot',
      callback: async (rightMenuItem) => {
        let component = await oxygenUtil.getComponent(client.value.ClientRight);
        formContainerTitle.value = 'Enable Session Bot';
        formRows.value = [
          {
            type: "input",
            name: "sessionBotPath",
            label: "Session Bot Path",
            value: (component && component.InitialContext && component.InitialContext.startJson) || "/Code/github/SimpliaV2Components/SessionBot/start.json"
          },

          {
            type: "button",
            css: "spaced-button",
            name: "set",
            text: "Set",
            size: "medium",
            view: "flat",
            color: "primary"
          },
          {
            type: "input",
            name: "CustomFunctionsPath",
            label: "Custom Functions Path",
            value: (component && component.InitialContext && component.InitialContext.CustomFunctions)|| ''
          },

          {
            type: "button",
            css: "spaced-button",
            name: "setCustomFunctions",
            text: "Set",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();


        formContainer.value.formInstance.getItem("set").events.on("click", async ()=>{
          let path;
          //console.log('addRole-click', 'role:',  formContainer.value.formInstance.getItem("roleName").getValue());
          if(path = formContainer.value.formInstance.getItem("sessionBotPath").getValue()) {
            await oxygenUtil.updateComponentEx(
                client.value.ClientRight,
                {
                  'set': {
                    'InitialContext.startJson': path
                  }
                }
            )
            formContainer.value.hide();
          }
        });

        formContainer.value.formInstance.getItem("setCustomFunctions").events.on("click", async ()=>{
          let path;
          //console.log('addRole-click', 'role:',  formContainer.value.formInstance.getItem("roleName").getValue());
          if(path = formContainer.value.formInstance.getItem("CustomFunctionsPath").getValue()) {
            await oxygenUtil.updateComponentEx(
                client.value.ClientRight,
                {
                  'set': {
                    'InitialContext.CustomFunctions': path
                  }
                }
            )
            formContainer.value.hide();
          }
        });
      }





    });
  }

  function addChangeDNOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-file-signature`,
      title: 'Update DisplayName',
      callback: async (rightMenuItem)=> {
        let DNs = await oxygenUtil.getGDN(client.value.ClientRight);
        let uuid = `c${oxygenUtil.getUUID()}`;
        //console.log('Update DisplayName', 'uuid:', uuid);
        formContainerTitle.value = 'Update DisplayName';
        formRows.value = [
          {
            css: uuid,
            type: "combo",
            name: "newDN",
            label: "New DisplayName",
            value: '',
            newOptions: true,
            data: DNs.map( (e)=> {
              return { value: e, id: e};
            })
          },
          {
            type: "button",
            css: "spaced-button",
            name: "update",
            text: "Update",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();
        window._formContainer = formContainer.value;
        let newDN;

        /*
        formContainer.value.formInstance.getItem("newDN").events.on("beforeChange", ()=>{
          console.log('Update DisplayName', 'val-1:', formContainer.value.formInstance.getItem("newDN").getValue());
          console.log('Update DisplayName', 'val-2:', window.document.querySelector(`.${uuid}`).querySelector("input").value);
          formContainer.value.formInstance.getItem("newDN").getValue() ||
          window.document.querySelector(`.${uuid}`).querySelector("input").value;
        });

         */

        formContainer.value.formInstance.getItem("newDN").events.on("blur", ()=>{
          //console.log('Update DisplayName', 'blur-val-1:', formContainer.value.formInstance.getItem("newDN").getValue());
          //console.log('Update DisplayName', 'blur-val-2:', window.document.querySelector(`.${uuid}`).querySelector("input").value);
          newDN = formContainer.value.formInstance.getItem("newDN").getValue() ||
          window.document.querySelector(`.${uuid}`).querySelector("input").value;
        });

        formContainer.value.formInstance.getItem("update").events.on("click", async ()=>{
          //console.log('Update DisplayName', 'val-1:', formContainer.value.formInstance.getItem("newDN").getValue());
          //console.log('Update DisplayName', 'val-2:', window.document.querySelector(`.${uuid}`).querySelector("input").value);
          //let newDN = formContainer.value.formInstance.getItem("newDN").getValue() ||
          //window.document.querySelector(`.${uuid}`).querySelector("input").value;
          newDN = formContainer.value.formInstance.getItem("newDN").getValue() || newDN;

          //console.log('Update DisplayName', 'newDN:', newDN);
          if(newDN) {
            await oxygenUtil.callCommonServiceAPI('oxygen-components', 'updateDisplayName',
                Object.assign({
                  OxygenID: client.value.ClientRight
                }, DNs.includes(newDN) ?
                    { DisplayName: newDN} : {DisplayNamePrefix: newDN}));
            let newItem = await oxygenUtil.getComponent(client.value.ClientRight);

            window.devStore.updateRootMenu({ Path: rootMenuItem.Path, RightDN: newItem.DisplayName });
            //window.devStore.rootMenu.find(e => e.ViewPortID === props.viewportID).RightDN =
            rootMenuItem.RightDN = client.value.ClientRightDN = newItem.DisplayName;

            formContainer.value.hide();
          }


        });
      }

    })
  }

  function addSystemDesignerOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-code`,
      title: 'Open System Designer',
      callback: async (rightMenuItem) => {


        let terminationUrl = {"MediaType":"Iframe","URL":`/SystemDesigner/index.html?${(new URLSearchParams({

              ContextPE: getContextPE,
              ClientID: props.ClientID,
              PanelID: props.viewportID
            }))}`};
        window.BotServices.openChildPanel({ClientID : props.ClientID, DisplayName : 'System Designer', Termination : terminationUrl}, ()=>{});




      }
    });
  }

  async function addSmartLinkOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-link`,
      title: 'Create Smart Link',

       callback: async (rightMenuItem) => {
        formContainerTitle.value = 'Create Smart Link';

        let roles = await oxygenUtil.getAllComponentsRoles(
            [
              {
                id: client.value.ClientRight,
                defaultRole: ['visitor']
              }
            ],
            [{componentId:client.value.ClientRight, role: "visitor"},{componentId: client.value.ClientRight, role: "admin"}],
            ['owner']
        );

        formRows.value = [
          {
            type: "select",
            name: "role",
            label: "Role",
            options: roles[ client.value.ClientRight].map(e => ({ value: e.role, content: e.role})),
            value: 'visitor'
          },
          {
            type: "input",
            name: "linkName",
            label: "Link Name",
            value: ''
          },
          {
            type: "input",
            name: "passcode",
            label: "Pass Code",
            value: '' //Add validation to see if it's 6-digit numeric
          },

          {
            name: "meeting",
            type: "checkbox",
            text: "Meeting",
            checked: true
          },
          {
            type: "input",
            name: "deeplink",
            label: "Smart Link",
            readonly: true,
            value: ''
          },

          {
            cols: [
              {
                type: "button",
                css: "spaced-button",
                name: "create",
                text: "Create",
                size: "medium",
                view: "flat",
                color: "primary",
                padding: 10
              },
              {
                type: "button",
                css: "spaced-button",
                name: "close",
                text: "Close",
                size: "medium",
                view: "flat",
                color: "primary",
                padding: 10
              }
            ]
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();

        formContainer.value.formInstance.getItem("create").events.on("click", async ()=>{

          formContainer.value.formInstance.getItem("deeplink").setValue(
              await createDeepLink(
                  formContainer.value.formInstance.getItem("meeting").getValue(),
                  formContainer.value.formInstance.getItem("role").getValue(),
                  formContainer.value.formInstance.getItem("passcode").getValue()
              )
          );

        });

        formContainer.value.formInstance.getItem("close").events.on("click", async ()=>{
          formContainer.value.hide();

        });

      }
    })
  }

  async function createDeepLink(isMeeting, role, passcode) {

    let payload = {
      //onLogin : [{action : 'open', role, component : client.value.ClientRight}],

      onLoad : [{action : {open : true, child : {DisplayName : 'Inbox', Termination : {
              MediaType : 'WebComponent',
              URL: '/simplia/dist/builds/inbox-wc/app.js',
              Template: 'oxygen-inbox',
              dataset: Object.assign({connectbot: true,initializeconversationmode: true}, isMeeting ? { contactsmode: 'meeting' } : {})
            }}}}]


    };

    console.log('createDeepLink', 'payload:', payload, ' - isMeeting:', isMeeting);

    const url = '/BotServices/bot/getSignedUrl';
    try {
      let meetingContext, meetingParams = '';
      if(isMeeting) {
        meetingContext = JSON.parse(client.value.MeetingContext);
        delete meetingContext.serverConfig;
        delete meetingContext.serverInfo;
        meetingParams = `&MeetingContext=${JSON.stringify(meetingContext)}`;
      }

      console.log('createDeepLink', 'meetingParams:', meetingParams);

      let req = await fetch(url, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          URL: `${window.location.origin}/DeviceManager/index.html?overlay=false${meetingParams}&inbox=true`,
          Role: role,
          Component: client.value.ClientRight,
          InitialContext: payload,
          URLType: 'SmartNumber',
          Protect: true,
          Password: passcode
        })
      });
      //console.log('createDeepLink', 'req:', req);
      let res = await req.json();
      //console.log('createDeepLink', 'res:', res);
      return res.ShortURL;
    }
    catch(e) {
      console.log('createDeepLink', 'Error:', e);
      return '';
    }
  }

  function addRoleOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-share-nodes`,
      title: 'Add Role',
      callback: async (rightMenuItem)=> {
        formContainerTitle.value = 'New Role';
        formRows.value = [
          {
            type: "input",
            name: "roleName",
            label: "Role Name",
            value: ''
          },

          {
            type: "button",
            css: "spaced-button",
            name: "add",
            text: "Add",
            size: "medium",
            view: "flat",
            color: "primary"
          }
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();


        formContainer.value.formInstance.getItem("add").events.on("click", async ()=>{
          let roleName;
          //console.log('addRole-click', 'role:',  formContainer.value.formInstance.getItem("roleName").getValue());
          if(roleName = formContainer.value.formInstance.getItem("roleName").getValue()) {
            await oxygenUtil.putGrant({
              onObject: client.value.ClientRight,
              onRole: roleName,
              toPE: clientContext.value.ToPE,
              fromPE: clientContext.value.FromPE,
              fromGrantId: clientContext.value.FromGrantID,
              byPE: clientContext.value.GrantPE,
              byGrantId: clientContext.value.GrantID,
            });
            formContainer.value.hide();
          }
        });
      }

    })
  }

  async function showListNameForm(list) {
    formContainerTitle.value = 'List Name';
    formRows.value = [
      {
        type: "input",
        name: "listName",
        label: "List Name",
        value: ''
      },

      {
        type: "button",
        css: "spaced-button",
        name: "save",
        text: "Save",
        size: "medium",
        view: "flat",
        color: "primary"
      }
    ];

    formContainer.value.showContainerAlignedToElementInViewport(
        document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
        'bottom',
        document.getElementById(props.viewportID).getBoundingClientRect()
    );

    await nextTick();


    formContainer.value.formInstance.getItem("save").events.on("click", async ()=>{
      let listName;

      if(listName = formContainer.value.formInstance.getItem("listName").getValue()) {
        //console.log('showListNameForm', 'calling SetProviderData', ' listName:', listName, ' - list:', list);
        window.DevMgr.SetProviderData(
            {ClientId : client.value.Client, TemplateId : '_FFFFFFFFFFFFFF00001668203009117626_', Data : list, DisplayName : listName}, (err, res) => {
              //console.log('showListNameForm', 'called SetProviderData', ' err:', err, ' - res:', res);
              formContainer.value.hide();
            });


      }
    });
  }

  function addUploadContactsOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-upload`,
      title: 'Contacts Upload',
      callback: async (rightMenuItem) => {
        if(client.value.childViewports && client.value.childViewports['showFiles']) {
          client.value.ignoreAttachmentCreation = true;
          let uploadId = oxygenUtil.getUUID();
          let uploadViewportId = client.value.childViewports['showFiles']();

          client.value.fileUploadCallbacks[uploadId] = async (uploadData) => {
            //console.log('addUploadContactsOption', 'fileUploadCallbacks', ' uploadData:', uploadData);
            let records = await getCSVData(uploadData.detail.filePath);
            //console.log('addUploadContactsOption', 'getCSVData', ' records:', records);
            client.value.ignoreAttachmentCreation = false;
            let responses = [];
            await async.each(records, async (record)=>{
              let response  = await addProviderSearchData(record);
              if(!response.error) {
                responses.push(response.result);
              }
              //console.log('addUploadContactsOption', 'addProviderSearchData', ' response:', response);
            });
            window.DevMgr.closeViewPort(uploadViewportId);
            await showListNameForm(responses);

          };

          //console.log('addUploadContactsOption', 'uploadViewportId:', uploadViewportId);
          await nextTick();
          await nextTick();
          await nextTick();
          let counter = 0;
          let intervalID = setInterval(()=>{
            let wc = document.querySelector(`iframe-container[data-viewportID="${uploadViewportId}"]`);
            //console.log('addUploadContactsOption', 'wc:', wc);
            if(counter > 10) {
              clearInterval(intervalID);
            }
            else if(wc && wc.shadowRoot && wc.shadowRoot.getElementById(wc.id) && wc.shadowRoot.getElementById(wc.id).contentWindow.uppy) {
              //console.log('addUploadContactsOption', 'uppy:', wc.shadowRoot.getElementById(wc.id).contentWindow.uppy);
              wc.shadowRoot.getElementById(wc.id).contentWindow.uppy.setOptions({
                restrictions: {
                  allowedFileTypes: ['.csv']
                }
              });
              wc.shadowRoot.getElementById(wc.id).contentWindow.uppy.on('upload-success', async (file, response) => {
                //console.log('upload-success', 'file:', file);
                //Call API to upload data to Master Provider
                //Do openPE on the list component template
              });
              clearInterval(intervalID);
            }
            else {
              counter++;
            }

          },200);
          return true;
        }
      }
    });
  }

  let schedulerContainerTitle = ref(''), schedulerContainer = ref(null), defaultViewArgs = ref([new Date(), 'week']);

  function addSetAvailability() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-calendar`,
      title: 'Set Availability',
      callback: async (rightMenuItem) => {
        schedulerContainerTitle.value = 'Set Availability';

        schedulerContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();
        await nextTick();
        await nextTick();
        let scheduler, attempts = 0;
        let interval = setInterval(async ()=>{
          //console.log('availability', 'calendar:', schedulerContainer.value.calendar);
          //console.log('availability', 'scheduler:', schedulerContainer.value.calendar._.data.mainScheduler);
          if(( attributionRecord && schedulerContainer.value.calendar && (scheduler = schedulerContainer.value.calendar._.data.mainScheduler)) || (attempts > 5)) {
            clearInterval(interval);
            let data = await oxygenUtil.callCommonServiceAPI('availability', 'get', { AttributionOID: attributionRecord.AttributionID });
            //console.log('availability', 'data:', data);
            let currentInterval = null, lastVal = 0;
            data.availability.split(" ").forEach((e, i, arr)=>{
              //console.log('availability', 'e:', e, ' - diff:', parseInt(e) - parseInt(lastVal), ' - t2:', parseInt(lastVal ) + 900000);
              if(!currentInterval) {
                currentInterval = { t1: parseInt(e)}
              }
              else {
                if(((parseInt(e) - parseInt(lastVal)) !== 900000 ) || (i === (arr.length - 1))  ) {
                  currentInterval.t2 = parseInt(lastVal ) + 900000;
                  scheduler.addEvent({ start_date: formatEventTime(currentInterval.t1),
                    end_date: formatEventTime(currentInterval.t2), text: 'Availability'});
                  currentInterval = null;
                }

              }
              lastVal = e;
            });

          }
          attempts++;
        },100);

      }
    });
  }

  function formatEventTime(timestamp) {
    //console.log('formatEventTime', 'timestamp:', timestamp);
    return new Date(timestamp).toISOString().replace('T', ' ').replace(/:..\..+$/,'');
  }



  function calendarEventCreated(data) {
    //console.log('calendarEventCreated', 'called - data:', data);

    //console.log('calendarEventCreated', 'schedulerContainer:', schedulerContainer.value);
    //console.log('calendarEventCreated', 'calendar:', schedulerContainer.value.calendar);
    //console.log('calendarEventCreated', 'scheduler:', schedulerContainer.value.calendar._.data.mainScheduler);
    let scheduler = schedulerContainer.value.calendar._.data.mainScheduler;

    scheduler.getEvent(data.id).text = "Available"; //changes event's data
    scheduler.updateEvent(data.id);   // renders the updated event
  }

  let schedulerButtons = reactive([
    { id: 'options', html: 'Options', callback: ()=>{
      }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
    { id: 'save', html: 'Save', callback: async ()=>{
        let scheduler = schedulerContainer.value.calendar._.data.mainScheduler;
        let data = scheduler.getEvents();
        let retData = await oxygenUtil.callCommonServiceAPI('availability', 'store', Object.assign({
          ranges: data.map((e)=>{
            return {
              t1: new Date(e.start_date).getTime(),
              t2: new Date(e.end_date).getTime()
            }
          }),
          ThreadId: client.value.ClientRight,
          replace: true
        }, attributionRecord ? { AttributionOID: attributionRecord.AttributionID,
          ParentAttributionOID: attributionRecord.ParentAttributionID, RootAttributionOID: attributionRecord.RootAttributionID } : {}));
        //console.log('scheduler-save-callback', 'retData:', retData);
      }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}}
  ]);

  async function getCSVData(filePath) {
    let data = await oxygenUtil.callCommonServiceAPI('csv-file-parser','parseFile', { filePath });
    return data.records;
  }

  async function addProviderSearchData(data) {
    let url = `/ProviderSearch-0026/Server/directories/create-update`;

    let response = await fetch(
        url,
        {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          mode: 'cors'
        }
    ).catch((e)=> {
      //console.log('addProviderSearchData', 'error:', e);
      throw e;
    });
    let responseObj;
    if(response.ok && (responseObj = await response.json())) {
      return responseObj;
    }
    return false;
  }

  function addSetProfileOption() {
    window.DevMgr.addRightMemu(props.viewportID, {
      icon: `fal fa-address-card`,
      title: 'Set Profile',
      callback: async (rightMenuItem)=> {
        console.log('setProfile-callback');
        /*
        let rows = await oxygenUtil.runDBQuery(
            `select * from OxygenDatabase.Attribution where CredentialPE = ? and AccountType = ?`,
            [ window.LivingScript_0070.context.credentialPE, 'PrimaryAccount' ]
        );

         */
        let rows;
        if(client.value.Attribution) {
          rows = await oxygenUtil.runDBQuery(
              `select * from OxygenDatabase.Attribution where ID = ?`,
              [ client.value.Attribution ]
          );
        }
        else {
          rows = await oxygenUtil.runDBQuery(
              `select * from OxygenDatabase.Attribution where CredentialPE = ? and AccountType = ?`,
              [ window.LivingScript_0070.context.credentialPE, 'PrimaryAccount' ]
          );
        }


        let existingSettings = {};
        if(rows.length) {
          existingSettings = rows[0];
        }

        //let isGateway = !(existingSettings.AccountType === "PrimaryAccount");
        //console.log('Set Profile', 'isGateway:', isGateway);

        let photoUrl =  existingSettings.picture;

        formContainerTitle.value = 'Set Profile';
        formRows.value = [
          {
            type: "input",
            name: "FirstName",
            label: "First Name",
            value:  existingSettings.given_name || '',
            padding: "10px"
          },
          {
            type: "input",
            name: "LastName",
            label: "Last Name",
            value: existingSettings.family_name || '',
            padding: "10px"
          },
          {
            type: "input",
            name: "Email",
            label: "Email",
            value:  existingSettings.email || '',
            padding: "10px",
          },
          {
            name: "Subject",
            type: "checkbox",
            text: "Subject Only",
            checked: false
          },
          {
            type: "input",
            name: "PhoneNumber",
            label: "Phone Number",
            value:  existingSettings.phone_number || '',
            padding: "10px",
          },
          {
            type: "textarea",
            name: "Address",
            label: "Address",
            value:  existingSettings.address || '',
            resizable: false,
            height: "135px",
            padding: "10px",
          },
          {
            type: "input",
            name: "Birthdate",
            label: "Birthdate",
            value: existingSettings.birthdate || '',
            placeholder: 'mm/dd/yyyy',
            padding: "10px"
          },
          {
            type: "select",
            name: "Gender",
            label: "Gender",
            value: existingSettings.gender || '',
            options: [
              { value: "", content: ""},
              { value: "male", content: "Male"},
              { value: "female", content: "Female"},
              { value: "other", content: "Other"},
            ],
            padding: "10px"
          },
          {
            type: "textarea",
            name: "Website",
            label: "Website",
            value:  existingSettings.website || '',
            resizable: false,
            height: "135px",
            padding: "10px",
          },
          {
            align: "start",
            cols: [
              {
                type: "button",
                css: "spaced-button",
                name: "uploadPhoto",
                text: "Upload Profile Photo",
                size: "medium",
                view: "flat",
                color: "primary",
                padding: "10px"
              },
              {
                type: "container",
                name: "upload-progress",
                padding: "10px",
                html: `<div></div>`
              }
            ]
          },
          {
            type: "button",
            css: "spaced-button",
            name: "save",
            text: "Save",
            size: "medium",
            view: "flat",
            color: "primary",
            padding: "10px"
          },
          {
            align: "start",
            cols: [
              {
                type: "input",
                inputType: "password",
                name: "Password",
                value: '',
                padding: "10px",
              },
              {
                type: "button",
                css: "spaced-button",
                name: "changepassword",
                text: "Change Password",
                size: "medium",
                view: "flat",
                color: "primary",
                padding: "10px"
              }

            ]
          },
        ];

        formContainer.value.showContainerAlignedToElementInViewport(
            document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
            'bottom',
            document.getElementById(props.viewportID).getBoundingClientRect()
        );

        await nextTick();

        window._formContainer = formContainer.value;

        formContainer.value.formInstance.getItem("uploadPhoto").events.on("click", async ()=>{
          let contextPE = oxygenUtil.isCredentialAccount(client.value) ?
              ( oxygenUtil.createSimpleOES(['admin', client.value.ClientRight, 'admin', client.value.ClientRight]) ):
              oxygenUtil.createSimpleOES(
                  [client.value.ClientLeftRole, client.value.ClientLeft, client.value.ClientRightRole, client.value.ClientRight]
              );
          let iframeViewportID = oxygenUtil.showIframeViewport(
              props.ClientID,
              oxygenUtil.getMainViewportID(client.value.Meeting),
              'UploadPhoto',
              'Upload Photo',
              `/OxygenFileServices-0070/s3.html?${(new URLSearchParams({
                bucket: 'n.simplia.com',
                ContextPE: contextPE,
                ClientID: props.ClientID,
                PanelID: props.viewportID}))}`
          );
          await nextTick();
          await nextTick();
          await nextTick();
          let counter = 0;
          let intervalID = setInterval(()=>{
            let wc = document.querySelector(`iframe-container[data-viewportID="${iframeViewportID}"]`);
            if(counter > 10) {
              clearInterval(intervalID);
            }
            else if(wc && wc.shadowRoot && wc.shadowRoot.getElementById(wc.id) && wc.shadowRoot.getElementById(wc.id).contentWindow.uppy) {
              let fileid = oxygenUtil.getGUID();
              wc.shadowRoot.getElementById(wc.id).contentWindow.uppy.setOptions({
                onBeforeFileAdded: (currentFile, files) => {
                  //console.log('onBeforeFileAdded', 'currentFile:', currentFile);
                  let fileExt = /^.+\.(.+)$/.exec(currentFile.name)[1];
                  const modifiedFile = {
                    ...currentFile,
                    name: `${fileid}.${fileExt}`
                  }
                  //console.log('onBeforeFileAdded', 'modifiedFile:', modifiedFile);

                  return modifiedFile
                }
              });

              wc.shadowRoot.getElementById(wc.id).contentWindow.uppy.on('upload-success', (file, response) => {
                //console.log('upload-success', 'file:', file);
                let parsedPE = oxygenUtil.parseOES(contextPE).segments
                photoUrl = `https://s3.amazonaws.com//n.simplia.com/${parsedPE[1]}/${parsedPE[3]}/${parsedPE[0]}/${parsedPE[2]}/${file.name}`;
                window.DevMgr.closeViewPort(iframeViewportID);
                formContainer.value.formInstance.getItem("upload-progress").attachHTML('<span style="color: green; font-size:24px;" class="fal fa-badge-check"></span>')
              });
              clearInterval(intervalID);
            }
            else {
              counter++;
            }

          },200);


        });

        formContainer.value.formInstance.getItem("save").events.on("click", async ()=>{
          await oxygenUtil.runDBQuery(

                  `update OxygenDatabase.Attribution set
given_name = ?,
family_name = ?,
picture = ?,
email = ?,
phone_number = ?,
address = ?,
birthdate = ?,
gender = ?
where ID = ?`,
              [
                  formContainer.value.formInstance.getItem("FirstName").getValue(),
                formContainer.value.formInstance.getItem("LastName").getValue(),
                photoUrl,
                formContainer.value.formInstance.getItem("Email").getValue(),
                formContainer.value.formInstance.getItem("PhoneNumber").getValue(),
                formContainer.value.formInstance.getItem("Address").getValue(),
                formContainer.value.formInstance.getItem("Birthdate").getValue(),
                formContainer.value.formInstance.getItem("Gender").getValue(),
                existingSettings.ID]
          );

          let parsedContextPE = oxygenUtil.parseOES(getContextPE()).segments;
          let subjectPE = oxygenUtil.createSimpleOES([parsedContextPE[2],parsedContextPE[3],parsedContextPE[2],parsedContextPE[3]]);
          if(!rows.length || existingSettings[`email`] !== formContainer.value.formInstance.getItem("Email").getValue() || formContainer.value.formInstance.getItem("Subject").getValue() ) {
            let grant = await oxygenUtil.getGrantFromPE(formContainer.value.formInstance.getItem("Subject").getValue() ? subjectPE : getContextPE());
            await oxygenUtil.callCommonServiceAPI(
                "simplia-api",
                'addTrackingRecord',
                {
                  relation: 'EmailToPE',
                  PE1: formContainer.value.formInstance.getItem("Email").getValue(),
                  PE2: formContainer.value.formInstance.getItem("Subject").getValue() ? subjectPE : getContextPE(),
                  extraParams: {
                    grantId: grant.GrantID
                  }
                }
            );
          }


          formContainer.value.hide();
        });

        formContainer.value.formInstance.getItem("changepassword").events.on("click", async ()=>{
            let email = oxygenUtil.formatDN(attributionRecord.CredentialRightDN),
                Username = oxygenUtil.isEmail(email) && email;
            if(Username) {
              try {
                await oxygenUtil.callCommonServiceAPI("simplia-api","setUserPassword",
                    { Username, Password: formContainer.value.formInstance.getItem("Password").getValue() });
                showAlertContainer('Change Password', `Password has been changed successfully`);
              }
              catch(e) {
                showAlertContainer('Change Password Error', e.toString());
              }
            }
            else {
              showAlertContainer('Change Password Error', 'Unable to find the username. Please contact the admin.');
            }
        });
      }

    });
  }

  async function addRightMenuOptions() {
    addSavePDFOption();
    addEmailSettingsOption();


    let adminRoles = ['admin', 'owner', 'holder'];
    if(adminRoles.includes(client.value.ClientRightRole)) {
      addSmartLinkOption();
      addRoleOption();
      //addSystemDesignerOption();
      addChangeDNOption();
      addEditContextOption();
      addEnableSessionBotOption();
      //addSetAvailabilityOption();
      //addChooseAppointmentOption();
      //addHistoryFormOption();
      //addDialogueCreatorOption();
      //addRoleTokenOption();
      addNewEmailOption();
      addMeetworkSettingsOption();
    }
    //console.log('addRightMenuOptions', 'adding addShowAppointmentsOptions');
    //addShowAppointmentsOption();

    addSetProfileOption();

    addUploadContactsOption();

    let viewportContext = oxygenUtil.getViewportContext(props.viewportID);
    let clientRight = await oxygenUtil.getComponent(client.value.ClientRight);
    ////console.log('addRightMenuOptions', 'clientRight:', clientRight, ' - includes:', clientRight.FFTTID.includes("2016-11-08T21:52:39.289240Z000-0000Z"));
    if(clientRight && clientRight.FFTTID && clientRight.FFTTID.includes("2016-11-08T21:52:39.289240Z000-0000Z")) {
      addDownloadFileOption();
    }

    //addSetAvailability();
  }

  const contextPE = ref(null);
  function getContextPE() {
    return (window.LivingScript_0070.context.credentialId  === client.value.ClientRight) ?
            ( oxygenUtil.createSimpleOES(['admin', client.value.ClientRight, 'admin', client.value.ClientRight]) ):
            oxygenUtil.createSimpleOES([client.value.ClientLeftRole, client.value.ClientLeft, client.value.ClientRightRole, client.value.ClientRight]);
  }

  async function makePDF(namePrefix, fullHeight) {
    //console.log('makePDF', 'fullHeight:', fullHeight);
    let url = `/OxygenFileServices-0070/companion/make-pdf`;

    let data = {
      "content": oxygenUtil.getViewportHTML(props.viewportID, fullHeight), // HTML content
      "name": namePrefix, // Provide GDN of the PDF if Grant needed
      "storage": "grant", // Option - pdf: if direct pdf is needed, s3: if s3 link, grant: create grants
      "toPE": getContextPE()// provide if grant needed otherwise optional
    };


    let response = await fetch(
        url,
        {
          method: 'POST',
          //body: new URLSearchParams(data),
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          mode: 'cors'
        }
    ).catch((e)=> {
      throw e;
    });

    let responseObj;
    if(response.ok && (responseObj = await response.json())) {
      return responseObj.data;
    }
    return false;
  }

  async function postEmailPDFHistoryTask() {
    let historyItem = await oxygenUtil.postHistoryMessage(Object.assign({
      PK: oxygenUtil.getGUID(),
      FromPE: this.GatewayPE,
      ToPE: this.dataRow.data.ByPE,
      ByPE: this.envelopeByPE ,
      CredentialPE: this.CredentialPE,
      AgentOfPE: this.AgentOfPE,
      GatewayPE: this.GatewayPE,
      //TransactionId: this.lastTransactionId,
      CausingEventID: this.dataRow.data.PK,
      ArgJSON: JSON.stringify(this.createAgreementArgJSON()),
      Note: this.dataRow.data.Note,
      EventLabel: this.dataRow.data.EventLabel,
      EventTemplate: "_FFFFFFFFFFFFFF00001664230222490180_",
      NoteTemplate: "MessageNoteTemplate-0056",
      NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
      TaskTemplateID: '_FF10313609901216306869076411514878_',
      FCX: {

      }
    },( this.geolocation && this.geolocation.location) ? {
      Lat: this.geolocation.location.latitude,
      Long: this.geolocation.location.longitude,
      IPAddress: this.geolocation.traits.ip_address,
      City: this.geolocation.city.names.en,
      State: this.geolocation.postal.code,
      Country: this.geolocation.country.names.en,
      GeoIPLocation: JSON.stringify(this.geolocation)
    } : {}));
  }

  let formContainerTitle = ref(''), formRows = ref([]), formContainer = ref(null);

  /**
   * Toggling Ribbon
   */
  let toggleRibbonTooltips = { 'show': 'Show Options', 'hide': 'Hide Options' }, toggleRibbonTooltip = ref(toggleRibbonTooltips.show), lastHeaderRibbonState = false;
  let emit = defineEmits(['header-toggled', 'desk-mode-toggled']);
  function toggleRibbon() {
    lastHeaderRibbonState = showHeaderRibbon.value = !showHeaderRibbon.value;
    emit('header-toggled', props.viewportID, lastHeaderRibbonState);
    if(showHeaderRibbon.value) {
      toggleRibbonTooltip.value = toggleRibbonTooltips.hide;
    }
    else {
      toggleRibbonTooltip.value = toggleRibbonTooltips.show;
      toggleSearch(false);
    }
    window.oxygenUtil.dispatchViewportEvent(props.viewportID, 'header-toggled', { headerRibbonState: lastHeaderRibbonState});
  }

  async function showUISettings() {
    formContainerTitle.value = 'UI Settings';
    formRows.value = [
      {
        type: "select",
        name: "template",
        label: "Template",

        options:[
          { value: '_FF10313609901216306869076411514878_', content: 'PlateTestTemplate'}
        ],
        value: '_FF10313609901216306869076411514878_'
      },
      {
        id: "documentHeight",
        name: "documentHeight",
        type: "radioGroup",
        required: true,
        labelPosition: "top",
        value: "entire",
        options: {
          rows: [
            {
              type: "radioButton",
              text: "Entire Document",
              value: "entire",
            },
            {
              type: "radioButton",
              text: "Visible Document",
              value: "visible"
            },
          ]
        }
      },
      {
        type: "input",
        name: "saveAsName",
        label: "Save As",
        value: client.value.ClientRightDN
      },
      /*{
        type: "input",
        label: 'Email',
        name: 'email'
      },*/
      {
        type: "button",
        css: "spaced-button",
        name: "saveAsPDF",
        text: "Save As PDF",
        size: "medium",
        view: "flat",
        color: "primary"
      }
    ];

    formContainer.value.showContainerAlignedToElementInViewport(
        document.getElementById(props.viewportID).querySelector(".main-panel-header-title"),
        'bottom',
        document.getElementById(props.viewportID).getBoundingClientRect()
    );

    await nextTick();
    //console.log('saveAsPDF-callback', 'formContainer:', formContainer);
    window._formContainer = formContainer.value;
    formContainer.value.formInstance.getItem("saveAsPDF").events.on("click", async ()=>{
      //formInstance.getItem("email").getValue()
      //console.log('saveAsPDF-callback');
      //await postEmailPDFHistoryTask();
      let component = await makePDF(formContainer.value.formInstance.getItem("saveAsName").getValue(), formContainer.value.formInstance.getItem("documentHeight").getValue() == "entire");
      formContainer.value.hide();
      window.BotServices.PullPE(
          {
            ByClientID : client.value.Client,
            InitialContext : {
              ByCLientID: client.value.Client
            },
            OpenPE : component.grants.adminGrant.GrantPE
          }
      );
    });
  }

  function panelTitleClicked() {
    let rootMenuItem = window.devStore.rootMenu.find(e => e.ViewPortID === oxygenUtil.getMainViewportIDFromClient(client.value.Client));
    //console.log('open-main-panel-callback', 'rootMenuItem:', rootMenuItem);
    //window.BotServices.PullRootMenu(rootMenuItem);
    window.BotServices.ActiveViewport(rootMenuItem.ViewportID);
  }

  let showSmartTicker = ref(true);

  const optionsMenuTitle = ref(''),
      optionsMenu = ref(),
      optionsMenuName = ref(`id${oxygenUtil.getUUID()}`),
      showOptionsMenuTitle = ref(true),
      showOptionsMenuCheckbox = ref(false),
      showOptionsMenuFolder = ref(false),
      optionsMenuFontSize = ref('16px'),
      optionsMenuWidth = ref('220px'),
      optionsMenuLimit = ref(9),
      rightAlignedOptionsMenu = ref(true), menuOptions = ref([]), optionsMenuTableParams = reactive({
    showCheckbox: false,
    showFolder: false,
    showRightMenu: false,
    hideCheckboxCol: true,
    cols: [
      {
        callback: () => {
        },
        header: 'Title',
        type: 'html'
      },
      {
        callback: () => {
        },
        header: 'Icon',
        type: 'icon'
      }
    ]
  });

  function addOptionsMenuOptions() {
    let tickerRow = (showSmartTicker.value ? ({
      icon: { type: 'html',
        html: `<span  class="far fa-eye-slash"></span>`
      },
      tooltip: 'Hide SmartTicker',
      title: 'Hide SmartTicker',
      callback: ()=>{
        optionsShown.value = false;
        toggleSmartTicker();
      },
      path: `00007`
    }) : ({
      icon: { type: 'html',
        html: `<span  class="far fa-eye"></span>`
      },
      tooltip: 'Show SmartTicker',
      title: 'Show SmartTicker',
      callback: ()=>{
        optionsShown.value = false;
        toggleSmartTicker();
      },
      path: `00007`
    }));

    menuOptions.value = [].concat(
        {
          icon: { type: 'html',
            html: `<span  class="far fa-home"></span>` },
          tooltip: 'Show Home Menu',
          title: 'Home Menu',
          callback: ()=>{
            optionsShown.value = false;
            window.showRootMenu();
          },
          path: `00001`
        },
        (   !!oxygenUtil.Cookies.get("accessToken")) ?
            {
              icon: { type: 'html',
                html: `<span  class="far fa-user"></span>` },
              tooltip: 'Show Login/Signup Screen',
              title: 'Login/Signup',
              callback: ()=>{
                optionsShown.value = false;
                let simpliaLoginModal = document.getElementById('simplia-Signin');
                simpliaLoginModal._instance.exposed.modalOpen();
              },
              path: `00002`
            } : [],
        (   !oxygenUtil.Cookies.get("accessToken")) ?
            {
              icon: { type: 'html',
                html: `<span  class="far fa-user"></span>` },
              tooltip: 'Logout',
              title: 'Logout',
              callback: ()=>{
                optionsShown.value = false;
                const ev = new CustomEvent('userSignedOut', { detail: { user: this.user } })
                window.dispatchEvent(ev)
              },
              path: `00003`
            } : [],
        {
          icon: { type: 'html',
            html: `<span  class="far fa-arrows-maximize"></span>` },
          tooltip: 'Restore Header & MessageBox',
          title: 'Restore',
          callback: ()=>{
            restoreHeader();
            oxygenUtil.callMessageBoxFnWithReturn(props.viewportID, 'setMessageBoxVisibility', [true]);
            optionsShown.value = false;

          },
          path: `00004`
        },
        {
          icon: { type: 'html',
            html: `<span  class="far fa-message"></span>` },
          tooltip: 'Displays Inbox',
          title: 'Show Inbox',
          callback: ()=>{
            optionsShown.value = false;
            client.value.childViewports.showInbox();
          },
          path: `00005`
        },
        {
          icon: { type: 'html',
            html: `<span  class="far fa-rotate-right"></span>` },
          tooltip: 'Removes cache',
          title: 'Hard Refresh',
          callback: ()=>{
            optionsShown.value = false;
            hardRefresh();
          },
          path: `00006`
        },
        tickerRow
    );
  }


  const toggleSmartTicker = () => {
    if (showSmartTicker.value == false) {
      document.dispatchEvent(new Event('showSmartTicker'))
      showSmartTicker.value = true;
    } else {
      document.dispatchEvent(new Event('hideSmartTicker'))
      showSmartTicker.value = false
    }
  }

  function hardRefresh() {
    // post fetch method
    fetch('/CommonServices-0025/CloudFront/Invalidate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        DomainName: window.top.location.hostname,
        Path: '/*'
      })
    }).then(r => {
      alert('The process of invalidating the CloudFront cache is in progress. Please revisit the site after 5 minutes.')
    })
        .catch(e => {
          alert(e.message)
        })
  }

  let deskMode = ref(false);
  async function toggleDeskMode(val) {
    console.log('toggleDeskMode',  'val:', val);
    if(!deskMode.value || val) {
      deskMode.value = true;
      headerRibbon.value.changeRibbonIconColor('desk_mode', 'red');
      headerRibbon.value.updateIconAttributes('desk_mode', { tooltip: 'Disable Stage Mode'});
      await enableDeskMode();
    }
    else {
      deskMode.value = false;
      headerRibbon.value.changeRibbonIconColor('desk_mode', 'black');
      headerRibbon.value.updateIconAttributes('desk_mode', { tooltip: 'Enable Stage Mode'});
      disableDeskMode();
    }

  }

  let alertContainerName = `container${oxygenUtil.getUUID()}`,
      alertContainerTitle= ref('Alert'),
      alertContainer = ref(null),
      alertContainerWidth = ref('400px'),
      alertContainerMessage = ref('');

  function showAlertContainer(title, message) {
    console.log('showAlertContainer', 'message:', message);
    alertContainerMessage.value = message;
    alertContainerTitle.value = title;
    alertContainer.value.showModalAlignedToElement(document.getElementById(props.viewportID).querySelector(".main-panel-header-title"), 'left', 'bottom');
  }

  let extendedTitle = ref('');
  function parseSubjectDN(DN) {
    let matches;
    if(matches = /^([^\/]+)\/(.+)$/.exec(DN)) {
      extendedTitle.value = matches[2];
      return matches[1];
    }
    return DN;
  }

  defineExpose({
    storeViewport,
    rightMenuOptions,
    leftMenu,
    rightMenu
  });
</script>


<style>
@import '@vuepic/vue-datepicker/dist/main.css';
@import 'node_modules/floating-vue/dist/style.css';

div:focus {
  outline: 0;
}

.reduce-font-icon{
  font-size: 75%
}

.enlarge-font-icon {
  font-size: 125%
}

.main-panel-header-title {
  height: 39px;
  color: rgb(0, 114, 197);
  display: flex;
  white-space: nowrap;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}

.header-left-container {
  flex-grow: 1;
  display:inline-flex;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
}

.oxygen-home-icon {
  cursor: pointer;
  /*padding-top: 4px;*/
  padding-left: 5px;
  padding-right: 5px;
  font-size: 1em;
}

.simplia-panel-title{
  min-width: 0;
  display: inline-flex;
}

.panel-index {
  cursor: pointer;
}

.thread-subject-title {
  overflow: hidden;
  display: inline-flex;
  align-items: center;
}

.title-thread-role,
.title-subject-role {
  cursor: pointer;
  padding-right: 5px;
}

.title-component {
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.rightmenu-container {
  flex-basis: 0;
  display: inline-flex;
  flex-direction: row-reverse;
  font-size: 1em;
}

.screen-size-icon{
  padding-left:10px;
  padding-right:10px;
  cursor: pointer;
}

.screen-size-icon-first {
  padding-right: 5px
}

.v-popper__popper--shown {
  z-index: 100000;
}
</style>
